<div class="card">
  <h2 class="page-title">Validation des Devis</h2>

  <mat-form-field class="filter-field">
    <mat-label>Filtre</mat-label>
    <input matInput (keyup)="applyFilter($event)">
  </mat-form-field>

<mat-table
  class="mat-elevation-z8 table-container" 
  [dataSource]="devisList" 
  matSort
  (matSortChange)="announceSortChange($event)">

    <ng-container matColumnDef="devisReference">
      <mat-header-cell *matHeaderCellDef mat-sort-header>N° Devis</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.devisReference ?? '—' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="devisMontantTotal">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Montant prév.</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.devisMontantTotal != null">{{ row.devisMontantTotal | number:'1.2-2' }} €</span>
        <span *ngIf="row.devisMontantTotal == null">—</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="devisBeneficiaire">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Bénéficiaire</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.devisBeneficiaire ?? '—' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="febDivisionDemandeurNom">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Division</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.febDivisionDemandeurNom ?? '—' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="febProjectNom">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Projet</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.febProjectNom ?? '—' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="devisDateDemarrageGo">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Démarrage</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span *ngIf="row.devisDateDemarrageGo">{{ row.devisDateDemarrageGo | date:'dd/MM/yyyy' }}</span>
        <span *ngIf="!row.devisDateDemarrageGo">—</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="devisDuree">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Durée (j)</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.devisDuree ?? '—' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="actions-td">Actions</mat-header-cell>
      <mat-cell *matCellDef="let row" class="actions-td">

        <button mat-icon-button
                (click)="openDevis(row)"
                matTooltip="Voir le devis">
          <mat-icon>visibility</mat-icon>
        </button>

       <button
          mat-icon-button
          style="color: green;"
          (click)="openValiderDialog(row)"
          matTooltip="Valider">
        <mat-icon>check_circle</mat-icon>
      </button>

        <button mat-icon-button
                color="warn"
                (click)="openRefuserDialog(row)"
                matTooltip="Refuser">
          <mat-icon>cancel</mat-icon>
        </button>

        <button mat-icon-button
                color="accent"
                (click)="openRetourDialog(row)"
                matTooltip="Retour en arrière (remettre en CRÉÉ)">
          <mat-icon>undo</mat-icon>
        </button>

      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

  </mat-table>

  <p *ngIf="devisList.data.length === 0" class="empty-msg">
    Aucun devis en attente de validation.
  </p>
</div>
